import React from 'react';
import 'remixicon/fonts/remixicon.css';

const Footer = () => {
  const footerStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'white',
    padding: '0.3rem 0.3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '3px solid #cec800',
    zIndex: 990,
    boxSizing: 'border-box',
    height: '60px'
  };

  const iconStyle = {
    margin: '0 15px',
    cursor: 'pointer',
    color: '#666666',
    fontSize: '24px'
  };

  const linkStyle = {
    textDecoration: 'none',
    color: 'inherit'
  };

  return (
    <footer style={footerStyle}>
      <a href="tel:+498934077791" style={linkStyle}>
        <i className="ri-phone-line" style={iconStyle}></i>
      </a>
      <a href="mailto:info@uweveronik.de" style={linkStyle}>
        <i className="ri-mail-line" style={iconStyle}></i>
      </a>
      <a href="https://www.instagram.com/physio.veronik?igsh=MTRmY2hmdGpqd2V4Mg%3D%3D&utm_source=qr" style={linkStyle} target="_blank" rel="noopener noreferrer">
        <i className="ri-instagram-line" style={iconStyle}></i>
      </a>
    </footer>
  );
};

export default Footer; 